export const mediaQuerySmall = '@media screen and (max-width: 40rem)'
export const mediaQueryMedium = '@media screen and (max-width: 68rem)'

// Container-query counterparts of the media queries above — for components that
// adapt to their own container width (e.g. placed in a narrow column) rather
// than the viewport. Requires an ancestor with `container-type: inline-size`.
export const containerQueryMedium = '@container (max-width: 56rem)'
